export enum MessageName {
    refreshOutgoingInvoices = "refreshOutgoingInvoices",
}
